import React from 'react'
import { ICONS } from '@Const/common'

interface DashboardLatestStatementsRowProps {
    payeeName: string
    statementsLink: string
    paymentStatus: string
    paymentAmount: number
}

const DashboardLatestStatementsRow = ({
    payeeName,
    statementsLink,
    paymentStatus,
    paymentAmount,
}: DashboardLatestStatementsRowProps) => (
    <a className="dashboard-statement-row" role="link" href={statementsLink}>
        <div className="dashboard-statement-name">
            <div className="dashboard-payee-name">{payeeName}</div>
            <img className="right-chevron" src={ICONS.chevron_right} alt="right chevron icon" />
        </div>
        <div>
            <div className="dashboard-statement-amt">
                {paymentAmount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}
            </div>
        </div>
        <div>
            <div className="dashboard-statement-status">{paymentStatus}</div>
        </div>
    </a>
)

export default DashboardLatestStatementsRow
